import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import API from "../../Services/BaseService";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import Logo from '../../assets/img/Logo_final.png';
import PageNotFound from '../FallBackUI/PageNotFound';
import "../ForgotPassword/forgotpassword.css"

const ForgotPasswordEmail = () => {
    const history = useHistory();
    const [email, setEmail] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);	
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [emailError, setEmailError] = useState('');

    const [emailErrors, setEmailErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm();
    const changehandleSubmit = (event) => {
        setEmailError("")

        //event.preventDefault();
        if(!email){
            setEmailError("Email ID is required")
            return;
        }
        else if(email && !new RegExp( /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(email)){
            setEmailError("Must match the email format")
            return;
        }

        let request = {
            email: email,
            // seller_id:successData.seller_id,
            // seller_token:successData.seller_token ,
        }
        API.post("seller_forgotPassword/condition", request).then((response) => {
            console.log("======111====>",response)
            if (response.data.success == true) {
                togglePopup()
                setPopupTitle("Forgot Password");
                setPopupMsg(" Password Link has been sent to given Email Id ");
                setPopupType("success");
                setPopupActionType("redirect");
                setPopupActionValue("ok");
                setPopupActionPath("/login")
            } else {
                const { data } = response;
                togglePopup()
                setPopupTitle("Forgot Password");
                // setPopupMsg("Forgot Password is not Updated, Please try Again");
                setPopupMsg(data.error.err);
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            }
        },
            (error) => {
                togglePopup()
                setPopupTitle("Error");
                setPopupMsg("Something went wrong, Please try Again");
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            })
            .catch(function (error) {
                if (error.response) {
                    setEmailErrors(error.response.data.error)
                    setErrorFlag(true)
                    
                }
            });
        
    }
    const togglePopup = () => {
        setIsOpen(!isOpen);
    }
    return (

        <div>
        <div>
            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={errors} /> :
                    <div className="col-lg-4  loginBlock forgotpage">
                        <button className="back-btn-paymentform backBtn" onClick={() => history.push("/login")}><i className="icofont-arrow-left"></i> Back</button>
                        <div className="col-lg-12 card">
                            <div className="logo"><img alt="" src={process.env.PUBLIC_URL + "/images/Logo_final.png"} /></div>
                            <form className="registrationform" onSubmit={handleSubmit(changehandleSubmit)} >
                                <h2 className="title">Forgot Password</h2>
                                <p className="error-message">{errorMessage}</p>
                                <div className="row changePassblock">

                                    <div className="col-sm-12 form-group">
                                        <div className="tbox">
                                            <input type="text" id="email" className="textbox" placeholder="" name="email" onChange={(e) => setEmail(e.target.value)} />
                                            <label htmlFor="email" className={email != "" ? "input-has-value" : ""}>Enter Your Email Id</label>
                                            <p className="form-input-error" >{emailError}</p>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 loginBtn">
                                        <button className="cta-btn">Submit</button>
                                    </div>
                                </div>
                            </form>

                        </div> </div>}
                        <section id="playstoreBlock" className="playstoreBlock">
                        <div className="container">
                            <div className="row content">
                                <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                                </div>
                            </div>
                        </div>
                    </section>
                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />}
            </main>

        </div>
    </div>
    )
}
export default ForgotPasswordEmail;